import axios from 'axios';
import { getAccessToken, getRefreshToken, updateAccessTokenAposRefresh, clearAll } from './authStorage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api',
});

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = getRefreshToken();
      if (refresh) {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/token/refresh/`,
            { refresh }
          );
          updateAccessTokenAposRefresh(res.data.access);
          original.headers.Authorization = `Bearer ${res.data.access}`;
          return api(original);
        } catch {
          clearAll();
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;